module.exports = __webpack_public_path__ + "static/media/Group 118.0889086b.png";